import { Disclosure, DisclosureButton, DisclosurePanel, Transition } from '@headlessui/react';
import classNames from 'classnames';
import { AppNextLink } from '@/features/app-next-link';
import { IconArrowSquareDown } from '@/components/svg-symbols/icons';
import { SubLink } from '../../types';
import { closeMenuOnNavigate } from '../../utils/close-menu-on-navigate';
interface Props {
  title: string;
  links: SubLink[];
  parentLink: string;
}
const closeSubMenuHandler = (close: () => void) => {
  setTimeout(() => {
    close();
  }, 1000);
  closeMenuOnNavigate();
};
function SubMenuExpandablePanel({
  title,
  links,
  parentLink
}: Props) {
  return <Disclosure data-sentry-element="Disclosure" data-sentry-component="SubMenuExpandablePanel" data-sentry-source-file="sub-menu-expandable-panel.tsx">
            {({
      open,
      close
    }) => <>
                    <DisclosureButton className={classNames('flex w-full items-center justify-between px-2 py-2.5 text-text-black', {
        'border-b border-border-gray-medium': !open
      })}>
                        <span className='text-sm font-medium leading-6'>{title}</span>

                        <IconArrowSquareDown className={classNames('h-6 w-6 transition-all duration-200', {
          'rotate-180': open
        })} />
                    </DisclosureButton>
                    <Transition as='div' className='overflow-hidden transition-all duration-200' enterFrom='transform max-h-0' enterTo='transform' leaveFrom='transform' leaveTo='transform max-h-0'>
                        <DisclosurePanel className='flex flex-col gap-0 border-b border-border-gray-medium text-xs font-medium text-text-darkGray [&>a]:px-2 [&>a]:py-2.5'>
                            <AppNextLink className='py-2.5 px-2' href={parentLink} prefetch={false} onClick={closeMenuOnNavigate}>
                                همه محصولات {title}
                            </AppNextLink>
                            {links.map((link, index) => {
            const linkHref = link.useHrefWithoutParent ? link.href : `${parentLink}${link.href}`;
            return <AppNextLink href={linkHref} key={`${link.title}${index}`} prefetch={false} className='py-2.5 px-2' onClick={() => closeSubMenuHandler(close)}>
                                        {link.title}
                                    </AppNextLink>;
          })}
                        </DisclosurePanel>
                    </Transition>
                </>}
        </Disclosure>;
}
export default SubMenuExpandablePanel;